import { createCrudEndpoints } from '../api'
import { RawOrganisationData } from './types'
import { RawTeamData } from '../teams/types'
import { managementApi } from '../../modules/servers/api'
import { teamsApi } from '../teams/api'

// TODO (important): when the get all query is hit we need to check if the selected org is still valid //
// if not we need to update in the store - if the response is empty - clear the store id //

export const organisationsApi = managementApi.injectEndpoints({
  endpoints: (builder) => ({
    // Generic CRUD endpoints //
    ...createCrudEndpoints<RawOrganisationData>('organisations', builder),

    // Organisation-Team endpoints //
    getUnlinkedTeams: builder.query<RawTeamData[], string>({
      query: (organisationId) =>
        `organisations/${organisationId}/unlinkedTeams`,
      providesTags: [{ type: 'unlinkedTeams', id: 'LIST' }]
    }),
    linkTeamWithOrg: builder.mutation<
      RawTeamData,
      { organisationId: string; body: { teamId: string } }
    >({
      query: ({ organisationId, body }) => ({
        url: `organisations/${organisationId}/teams`,
        method: 'POST',
        body
      }),
      invalidatesTags: [{ type: 'unlinkedTeams', id: 'LIST' }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(teamsApi.util.invalidateTags([{ type: 'teams', id: 'LIST' }]))
      }
    }),
    unlinkTeamFromOrg: builder.mutation<
      void,
      { organisationId: string; teamId: string }
    >({
      query: ({ organisationId, teamId }) => ({
        url: `organisations/${organisationId}/teams/${teamId}`,
        method: 'DELETE'
      }),
      invalidatesTags: [{ type: 'unlinkedTeams', id: 'LIST' }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(teamsApi.util.invalidateTags([{ type: 'teams', id: 'LIST' }]))
      }
    })
  })
})

export const {
  useOrganisations_getAllQuery,
  useOrganisations_getByIdQuery,
  useOrganisations_createMutation,
  useOrganisations_updateMutation,
  useGetUnlinkedTeamsQuery,
  useLinkTeamWithOrgMutation,
  useUnlinkTeamFromOrgMutation
} = organisationsApi
